import Swiper from 'swiper';
import { A11y, Navigation, Pagination, Keyboard } from 'swiper/modules';
import './travel-extension.scss';

class TravelExtension {
    constructor (element) {
        this.$root = element;
        this.$slider = this.$root.querySelector('[data-travel-extension="slider"]');
        this.$$filterOptions = this.$root.querySelectorAll('[data-travel-extension-option]');
        this.$prevButton = this.$root.querySelector('.swiper-button-prev');
        this.$nextButton = this.$root.querySelector('.swiper-button-next');
        this.$pagination = this.$root.querySelector('.swiper-pagination');
        this.slider = null;
        this.$$slides = null;
        this.activeSlideCategory = null;
        this.storedSlides = [];
    }

    initialize () {
        if (this.$slider) {
            this.initSlider();
        }
    }

    storeSlides () {
        this.$$slides = this.$slider.querySelectorAll('[data-travel-extension-slide-category]');

        this.storedSlides = Array.from(this.$$slides).map(slide =>
            slide.cloneNode(true)
        );
    }

    initFilterOptions () {
        this.$$filterOptions.forEach(($filterOption) => {
            $filterOption.onclick = () => {
                this.$$filterOptions.forEach(($options) => {
                    if ($options !== $filterOption) {
                        $options.setAttribute('aria-selected', false);
                        this.setActiveSlides($options.dataset.travelExtensionOption, false);
                    }
                });

                if ($filterOption.getAttribute('aria-selected') === 'true') {
                    $filterOption.setAttribute('aria-selected', 'false');

                    this.setActiveSlides($filterOption.dataset.travelExtensionOption, false);
                } else {
                    $filterOption.setAttribute('aria-selected', 'true');

                    this.setActiveSlides($filterOption.dataset.travelExtensionOption, true);
                }
            };
        });
    }

    initSlider () {
        this.slider = new Swiper(this.$slider, {
            modules: [A11y, Navigation, Pagination, Keyboard],
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            lazyPreloadPrevNext: true,
            loop: false,
            speed: 500,
            keyboard: true,
            a11y: {
                prevSlideMessage: window.translations.slider.prevSlideMessage,
                nextSlideMessage: window.translations.slider.nextSlideMessage,
                paginationBulletMessage: window.translations.slider.paginationBulletMessage,
                firstSlideMessage: window.translations.slider.firstSlideMessage,
                lastSlideMessage: window.translations.slider.lastSlideMessage,
                slideLabelMessage: window.translations.slider.slideLabelMessage
            },
            pagination: {
                el: this.$pagination,
                type: 'progressbar'
            },
            navigation: {
                nextEl: this.$nextButton,
                prevEl: this.$prevButton
            }
        });

        this.storeSlides();
        this.initFilterOptions();
    }

    setActiveSlides (slideCategory, isActive) {
        this.activeSlideCategory = slideCategory;

        if (this.$$slides.length > 0) {
            this.$$slides.forEach(($slide) => {
                if ($slide.dataset.travelExtensionSlideCategory !== 'global' && $slide.dataset.travelExtensionSlideCategory !== this.activeSlideCategory && isActive === true) {
                    $slide.classList.add('travel-extension-teaser--inactive');

                    setTimeout(() => {
                        $slide.remove();
                        this.slider.update();
                    }, 290);
                }
            });
        }

        if (isActive === false) {
            this.slider.wrapperEl.innerHTML = '';

            this.storedSlides.forEach($slide => {
                const $slideModalCta = $slide.querySelector('[data-modal]');

                if ($slide.classList.contains('travel-extension-teaser--inactive')) {
                    $slide.classList.remove('travel-extension-teaser--inactive');
                }

                if ($slideModalCta.hasAttribute('data-modal-init')) {
                    $slideModalCta.removeAttribute('data-modal-init');
                }

                window.dispatchEvent(new CustomEvent('content.loaded', {
                    view: window,
                    bubbles: true,
                    cancelable: false,
                    detail: {
                        $context: $slide
                    }
                }));

                this.slider.wrapperEl.append($slide);
            });

            this.$$slides = this.$slider.querySelectorAll('[data-travel-extension-slide-category]');
            this.activeSlideCategory = null;
            this.slider.update();
        }
    }
}

export { TravelExtension };

window.addEventListener('content.loaded', (e) => {
    const $context = e.detail.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-travel-extension="root"]:not([data-init="true"])');

        $$roots.forEach($root => {
            const $rootAPI = new TravelExtension($root);
            $rootAPI.initialize();
            $root.setAttribute('data-init', 'true');
        });
    }
});
